import React, { useState } from "react";
import ArticleLeftBar from "./ArticlesLeftBar";
import ArticleEditor from "./ArticleEditor";
import { useSelector } from "react-redux";

function WriteArticleView() {
  const [activeArticle, setActiveArticle] = useState(null);

  const userState = useSelector((state) => state.user);

  // Sélection d'un article
  const handleSelectArticle = async (article) => {
    if (!article) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Article/GetArticleById/${article.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userState.token}`,
          },
        }
      );

      if (!response.ok) throw new Error(`${response.status}: ${response.statusText}`);

      const result = await response.json();
      setActiveArticle(result);

      // Vérification du lock
      if (article.employeLock && article.employeLock !== userState.username) {
        alert(`This article is locked by ${article.employeLock} and can be incomplete`);
      }
    } catch (error) {
      console.error("Error fetching article:", error);
    }
  };

  return (
    <div className="EditArticle__Editor">
      <ArticleLeftBar selectArticle={handleSelectArticle} />
      <ArticleEditor article={activeArticle} setArticle={setActiveArticle} />
    </div>
  );
}

export default WriteArticleView;
